var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTupas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "123.000000pt",
    viewBox: "0 0 300.000000 123.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,123.000000) scale(0.050000,-0.050000)",
    fill: "#4682b4",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5329 1881 c-221 -34 -289 -118 -289 -351 0 -269 124 -369 460 -370 301 -2 360 -38 360 -223 0 -222 -42 -260 -300 -269 -307 -11 -365 17 -380 187 l-10 112 -70 0 -70 -1 6 -117 c11 -249 121 -314 504 -303 402 13 501 127 440 506 -31 191 -77 215 -466 247 -316 26 -364 64 -341 273 19 168 89 199 417 185 198 -8 230 -30 230 -161 0 -76 0 -76 81 -76 l81 0 -13 95 c-35 237 -250 327 -640 266z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1810 l0 -70 215 0 215 0 -6 -601 -5 -601 73 6 74 6 -4 595 -5 595 222 0 221 0 0 70 0 70 -500 0 -500 0 0 -70z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220 1331 c0 -742 12 -765 429 -786 551 -28 591 29 591 848 l0 487 -75 0 -75 0 0 -525 c0 -698 10 -676 -320 -685 -415 -12 -410 -20 -410 689 l0 521 -70 0 -70 0 0 -549z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2580 1210 l0 -672 72 6 73 6 -4 263 -3 263 320 7 c446 10 510 62 498 407 -13 352 -51 378 -567 387 l-389 6 0 -673z m687 531 c112 -26 122 -44 130 -239 6 -163 3 -179 -43 -234 l-50 -58 -292 -7 -292 -7 0 282 0 282 235 0 c129 -1 270 -9 312 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4162 1836 c-9 -26 -91 -253 -180 -506 -162 -455 -245 -687 -272 -755 -12 -29 -3 -35 57 -35 82 0 89 9 143 170 l40 120 330 5 330 6 50 -146 c49 -143 51 -145 125 -151 85 -7 88 1 42 109 -19 42 -125 333 -238 647 l-204 570 -103 6 c-91 5 -104 1 -120 -40z m208 -321 c42 -124 102 -295 133 -381 31 -86 57 -165 57 -175 0 -11 -121 -19 -281 -19 -229 0 -281 5 -275 27 19 83 268 773 278 773 7 0 47 -101 88 -225z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTupas);
export default __webpack_public_path__ + "static/media/tupas.fcda7c6902532d24f085c41a284b84d1.svg";
export { ForwardRef as ReactComponent };